import { createGlobalStyle } from 'styled-components';

import ThemeProvider from 'providers/ThemeProvider';
import { ThemeProvider as ThemeContextProvider } from 'contexts/ThemeContext'; // Import the provider
import Web3Provider from 'providers/Web3Provider';

import Pages from 'pages';

import 'services';

import GilroyRegular from 'fonts/Gilroy-Regular.woff';
import GilroyMedium from 'fonts/Gilroy-Medium.woff';
import GilroyBold from 'fonts/Gilroy-Bold.woff';
import GilroyExtraBold from 'fonts/Gilroy-ExtraBold.woff';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Gilroy';
    src: url(${GilroyRegular}) format('woff');
    font-weight: 400;
  }
  @font-face {
    font-family: 'Gilroy';
    src: url(${GilroyMedium}) format('woff');
    font-weight: 500 600;
  }
  @font-face {
    font-family: 'Gilroy';
    src: url(${GilroyBold}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Gilroy';
    src: url(${GilroyExtraBold}) format('woff');
    font-weight: 800;
  }
  html {
    -webkit-tap-highlight-color: transparent;
  }
  body {
    margin: 0;
    font-family: 'Gilroy';
    background-color: ${props => props.theme.isDark ? '#17191a' : 'transparent'}; 
  }
  button, input, textarea, .Toastify__toast {
    font-family: 'Gilroy';
  }
  #root {
    position: relative;
    overflow-x: hidden;
    min-height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: ${props => props.theme.background};
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
`;


export default () => (
  <ThemeContextProvider>
    <ThemeProvider>
      <GlobalStyle />
      <Web3Provider>
        <Pages />
      </Web3Provider>
    </ThemeProvider>
  </ThemeContextProvider>
);
